import { useIntl } from "react-intl";

export const useRuleTranslation = () => {
  const intl = useIntl();

  const subscribeEnabledText = intl.formatMessage({
    id: "subscribeEnabled",
  });
  const subscribeDisabledText = (companyName) =>
    intl.formatMessage({ id: "subscribeDisabled" }, { company: companyName });

  const companyDeliverySubscription = (companyName) =>
    intl.formatMessage(
      { id: "companyDeliverySubscription" },
      { company: companyName },
    );
  const subscribeToCompanyDelivery = (companyName) =>
    intl.formatMessage(
      { id: "subscribeToCompanyDelivery" },
      { company: companyName },
    );

  return {
    subscribeEnabledText,
    subscribeDisabledText,
    companyDeliverySubscription,
    subscribeToCompanyDelivery,
  };
};
